module.exports = __webpack_public_path__ + "static/img/4.f8ef4be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/zh/4.png
// module id = jTAp
// module chunks = 0